import { useContext, useEffect, useRef } from "react";
import { CustomerSyncContext } from "../Context/CustomerSyncContext";
import { AuthContext } from "../Context/AuthContext";

const POLL_INTERVAL_MS = 5000;

const hasAuthUser = (user) =>
  !!(user && typeof user === "object" && (user.user_auth_token || user.id));

const CustomerSyncPolling = () => {
  const customerSync = useContext(CustomerSyncContext);
  const { authState } = useContext(AuthContext);
  const user = authState?.user ?? null;
  const activeSyncs = customerSync?.activeSyncs ?? [];

  const activeSyncsRef = useRef(activeSyncs);
  const pollSyncRunRef = useRef(customerSync?.pollSyncRun);
  const userRef = useRef(user);

  useEffect(() => {
    activeSyncsRef.current = activeSyncs;
    pollSyncRunRef.current = customerSync?.pollSyncRun;
    userRef.current = user;
  });

  useEffect(() => {
    customerSync?.setUser?.(user);
  }, [customerSync?.setUser, user]);

  useEffect(() => {
    const pollAll = () => {
      if (!hasAuthUser(userRef.current)) return;

      const syncs = activeSyncsRef.current;
      if (syncs.length === 0) return;

      syncs.forEach((syncState) => {
        if (syncState.syncRunId == null || syncState.userId == null) return;
        pollSyncRunRef.current?.(
          userRef.current,
          syncState.syncRunId,
          syncState.userId
        );
      });
    };

    const intervalId = setInterval(pollAll, POLL_INTERVAL_MS);
    return () => clearInterval(intervalId);
  }, []);

  return null;
};

export default CustomerSyncPolling;
